const mergeLiaGenerateResult = (prev, data) => {
  const next = { ...prev, ...(data?.workflow || {}) };
  const ai = data?.ai;

  if (!ai) {
    return next;
  }

  if (ai.purpose) next.lia_purpose = ai.purpose;
  if (ai.necessity) next.lia_necessity = ai.necessity;
  if (ai.balancing) next.lia_balancing = ai.balancing;
  if (ai.summary) next.lia_summary = ai.summary;

  return next;
};

export default mergeLiaGenerateResult;
